module.exports = __webpack_public_path__ + "static/img/img-install-tag-car-support.45cc80f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/install-guide/img-install-tag-car-support.svg
// module id = 1792
// module chunks = 1